var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      parseInt(_vm.polygonVectorLayersLength) > 0
        ? _c(
            "div",
            { staticClass: "dd-action-bar" },
            [
              _c(
                "b-button",
                {
                  staticClass: "dd-action-btn dd-action-btn--primary",
                  attrs: {
                    disabled: _vm.polygonsSelected.length < 1,
                    id: "statsBtn",
                    title: "Generate Statistics",
                  },
                  on: { click: _vm.initStatsModal },
                },
                [
                  _c("fa", {
                    staticClass: "dd-action-btn__icon",
                    attrs: { icon: ["fa", "chart-bar"] },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Statistics")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "dd-action-btn dd-action-btn--ghost",
                  attrs: { title: "Clear Polygon" },
                  on: { click: _vm.clearPolygon },
                },
                [
                  _c("fa", {
                    staticClass: "dd-action-btn__icon",
                    attrs: { icon: ["fa", "eraser"] },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Clear")]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("DDT_StatisticsWindow", {
        attrs: {
          polygons: _vm.polygons,
          selectedExtent: _vm.selectedExtent,
          user: _vm.user,
        },
        on: {
          removePolygons: function ($event) {
            return _vm.$emit("removePolygons")
          },
          notification: function ($event) {
            return _vm.$emit("notification", $event)
          },
          "admin-notification": function ($event) {
            return _vm.$emit("admin-notification", $event)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }